/* eslint-disable camelcase -- Stream Chat attachment fields use snake_case */
import { useState } from 'react';
import {
	BaseImage,
	ImageProps,
	Modal,
	ModalGallery,
	useComponentContext,
	DefaultStreamChatGenerics,
} from 'stream-chat-react';
import { getFileUrl } from 'core/media/uploadPreparedMedia';
import { getAttachmentCategory } from 'shared/components/Attachments/attachmentUtils';
import CustomFileAttachment from '../CustomAttachment/CustomFileAttachment';

const CustomImage = (props: ImageProps<DefaultStreamChatGenerics>) => {
	const { dimensions = {}, fallback, image_url, thumb_url, innerRef, previewUrl, style } = props;
	const [modalIsOpen, setModalIsOpen] = useState(false);

	const { BaseImage: ContextBaseImage = BaseImage, ModalGallery: ContextModalGallery = ModalGallery } =
		useComponentContext('ImageComponent');

	const rawSrc = previewUrl || image_url || thumb_url || '';
	const category = getAttachmentCategory(rawSrc || fallback || '');

	const toggleModal = () => setModalIsOpen(isOpen => !isOpen);

	if (category !== 'image') {
		return <CustomFileAttachment attachment={props as any} />;
	}

	const imageSrc =
		rawSrc &&
		!rawSrc.startsWith('http://') &&
		!rawSrc.startsWith('https://') &&
		!rawSrc.startsWith('blob:') &&
		!rawSrc.startsWith('data:')
			? getFileUrl(rawSrc)
			: rawSrc;

	return (
		<>
			<ContextBaseImage
				alt={fallback}
				className="str-chat__message-attachment--img"
				data-testid="image-test"
				onClick={toggleModal}
				src={imageSrc}
				style={style}
				tabIndex={0}
				{...dimensions}
				{...(innerRef && { ref: innerRef })}
			/>
			<Modal onClose={toggleModal} open={modalIsOpen}>
				<div className="str-chat__image-modal">
					<ContextModalGallery images={[props]} index={0} />
				</div>
			</Modal>
		</>
	);
};

export default CustomImage;
